import React from "react";
import { message, Form, Badge } from "antd";
import styled from "styled-components";
import { UnorderedListOutlined } from "@ant-design/icons";

import colors from "constants/palette";
import Button from "components/buttons/Button";
import Fetch from "components/Fetch";
import { StyledModal } from "components/App/styled";
import Input, { TextArea } from "components/inputs/Input";

import { HeaderCard } from "pages/dashboard/UserDashboard";

export default function App({ visible, setVisible, reload, userData }) {
  const [form] = Form.useForm();

  const userDetailData = JSON.parse(userData.data);
  console.log(8878888888888888888, userData.data);
  const [loading, setLoading] = React.useState(false);
  const [list, setList] = React.useState(
    userDetailData?.todo ? userDetailData.todo : []
  );

  const showModal = () => {
    setVisible(true);
  };

  const onSubmit = (data) => {
    const newList = [...list, { ...data, checked: false }];
    setLoading(true);
    // add :::::::::
    Fetch.put(
      `/users/${userData.id}`,
      {
        data: JSON.stringify({
          ...JSON.parse(userData.data),
          todo: newList,
        }),
      },
      (res) => {
        console.log("new product response/ UPDATE", res);
        if (res?.success) {
          message.success("با موفقیت آپدیت شد");
          cleanForm();
          setList(newList);
        } else {
          if (res?.errors?.title) {
            message.error(res?.errors.title[0]);
          } else {
            message.error("خطایی رخ داده است");
          }
        }
      }
    );
    setLoading(false);
  };
  const handleOk = () => {
    form.submit();
  };

  const handleCancel = () => {
    setVisible(false);
  };
  const cleanForm = () => {
    form.setFieldsValue({
      title: null,
      stock: null,
      price: null,
      description: null,
    });
  };

  if (userData) {
    form.setFieldsValue(userData);
  }

  return (
    <>
      <Badge count={list.length}>
        <HeaderCard
          style={{ background: "#fbbc04", color: colors.white }}
          onClick={showModal}
        >
          <UnorderedListOutlined
            style={{ fontSize: 32, color: colors.black }}
          />
          چک لیست
        </HeaderCard>
      </Badge>

      <StyledModal
        title={"چک لیست"}
        visible={visible}
        onOk={onSubmit}
        onCancel={handleCancel}
        closable={false}
        footer={[
          <Button
            onClick={handleCancel}
            style={{ width: "100%" }}
            color={colors.blue}
          >
            بستن
          </Button>,
        ]}
        width={680}
      >
        <ColContainer>
          <Col>
            {list.map((item, key) => (
              <ListItem key={key}>
                <ListTitle>{item.title}</ListTitle>
                <ListDescription>{item.description}</ListDescription>
              </ListItem>
            ))}
          </Col>
          <Col>
            <Form
              form={form}
              layout="vertical"
              style={{ direction: "rtl" }}
              //   requiredMark={requiredMark}
              onFinish={onSubmit}
            >
              <Label>عنوان :</Label>
              <Form.Item
                name="title"
                rules={[
                  { required: true, message: "لطفا عنوان را وارد کنید!" },
                ]}
              >
                <Input size="large" placeholder="" />
              </Form.Item>

              <Label>توضیحات :</Label>
              <Form.Item name="description">
                <TextArea rows={5} />
              </Form.Item>
              <Button
                key="submit"
                type="primary"
                loading={loading}
                onClick={handleOk}
                style={{ width: "100%" }}
                color={colors.blue}
              >
                ثبت
              </Button>
            </Form>
          </Col>
        </ColContainer>
      </StyledModal>
    </>
  );
}
const ColContainer = styled.div`
  display: flex;
  justify-content: space-between;

  @media (max-width: 480px) {
    flex-direction: column;
  }
`;
const Col = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 200px;
`;
const Label = styled.label`
  margin-bottom: 10px;
  display: block;
  color: ${colors.dark};
`;
const ListItem = styled.div`
  padding-bottom: 16px;
`;
const ListTitle = styled.div`
  font-size: 1rem;
  font-weight: bold;
`;
const ListDescription = styled.div``;
